export default "__VITE_ASSET__wwNQZ859__"